module.exports = __webpack_public_path__ + "img/image01_sp.6fd9ea3d.jpg";